<template>
  <div class="editor-information">
    <div class="logo-container">
      <Logo :user="editor" />
    </div>
    <div class="information-container">
      <div class="editor-name">{{editor.name}}</div>
      <div class="update-time">{{formatDateTime(timeStamp)}}</div>
    </div>
  </div>
</template>

<script>
import dateFormatter from '@/utils/dateFormatter';
import Logo from '@/components/Logo.vue';

export default {
  mixins: [dateFormatter],
  components: {
    Logo,
  },
  props: {
    editor: {
      type: Object,
      default: () => {},
    },
    timeStamp: {
      type: String,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.editor-information {
  display: flex;
  align-items: center;

  .logo-container {
    margin-right: $spacer;
  }
  .information-container {
    .editor-name {
      font-weight: bold;
      margin-bottom: $spacer * 0.25;
    }
  }
}

</style>
